import {mapState} from "vuex";

const ExternalLogin = {
  computed: {
    ...mapState({
      externalLogin: state => state.settings.externalLogin,
    }),
    isGoogleLoginEnabled() {
      return !!this.externalLogin.google;
    },
    isFacebookLoginEnabled() {
      return !!this.externalLogin.facebook;
    },
    isAppleLoginEnabled() {
      return !!this.externalLogin.apple;
    },
    isAppleV2LoginEnabled() {
      return !!this.externalLogin.apple2;
    },
    isAnyExternalLoginEnabled() {
      return this.externalLogin.google
        || this.externalLogin.facebook
        || this.externalLogin.apple
        || this.externalLogin.apple2;
    },
  },
  watch: {
    externalLogin: {
      deep: true,
      handler() {
        if (!this.isAnyExternalLoginEnabled) {
          this.$router.push({name: 'SignIn'});
        }
      }
    }
  }
};

export default ExternalLogin;
